// Use runtime config for environment variable, fallback to process.env for local development
const runtimeConfig = window.__RUNTIME_CONFIG__ || {};
const env = runtimeConfig.REACT_APP_FW_ENV || process.env.REACT_APP_FW_ENV || 'local';

var BINGAPIKEY = process.env.REACT_APP_BINGAPIKEY;
var CERBOSURL = env === "prod" ? process.env.REACT_APP_CERBOS_URL : process.env.REACT_APP_CERBOS_URL_DEVTEST;
var APIURL;
var ONBOARDAPIURL;
var REFERRALAPIURL;
var SCOPE;
var CLIENT_ID;
var SEGMENTAPIKEY;
var GOOGLEMAPSAPIKEY = runtimeConfig.REACT_APP_GOOGLEMAPSAPIKEY || process.env.REACT_APP_GOOGLEMAPSAPIKEY;

if (env === "prod") {
  APIURL = process.env.REACT_APP_APIURL_PROD;
  SCOPE = process.env.REACT_APP_SCOPE_PROD;
  CLIENT_ID = process.env.REACT_APP_CLIENT_ID_PROD;
  ONBOARDAPIURL = process.env.REACT_APP_ONBOARDAPIURL_PROD;
  SEGMENTAPIKEY = process.env.REACT_APP_SEGMENTAPIKEY_PROD;
} else if (env === "test") {
  APIURL = process.env.REACT_APP_APIURL_TEST;
  SCOPE = process.env.REACT_APP_SCOPE_TEST;
  CLIENT_ID = process.env.REACT_APP_CLIENT_ID_TEST;
  ONBOARDAPIURL = process.env.REACT_APP_ONBOARDAPIURL_TEST;
  SEGMENTAPIKEY = process.env.REACT_APP_SEGMENTAPIKEY_DEVTEST;
} else if (env === "dev") {
  APIURL = process.env.REACT_APP_APIURL_DEV;
  SCOPE = process.env.REACT_APP_SCOPE_DEV;
  CLIENT_ID = process.env.REACT_APP_CLIENT_ID_DEV;
  ONBOARDAPIURL = process.env.REACT_APP_ONBOARDAPIURL_DEV;
  REFERRALAPIURL = process.env.REACT_APP_REFERRALAPIURL_DEV;
  SEGMENTAPIKEY = process.env.REACT_APP_SEGMENTAPIKEY_DEVTEST;
} else {
  APIURL = process.env.REACT_APP_APIURL_LOCAL;
  SCOPE = process.env.REACT_APP_SCOPE_DEV;
  CLIENT_ID = process.env.REACT_APP_CLIENT_ID_DEV;
  ONBOARDAPIURL = process.env.REACT_APP_ONBOARDAPIURL_DEV;
  REFERRALAPIURL = process.env.REACT_APP_REFERRALAPIURL_DEV;
  SEGMENTAPIKEY = process.env.REACT_APP_SEGMENTAPIKEY_DEVTEST;
}

var MUI_KEY = process.env.REACT_APP_MATERIAL_UI_LICENSE_KEY;
var MSTENANT = process.env.REACT_APP_MSTENANT;

var VERSION = '4.1.0'
var VERSION_DATE = '2026-09-01';

var JITSI_SERVER_URL = 'https://meet.eastus.cloudapp.azure.com';

export { APIURL, BINGAPIKEY, GOOGLEMAPSAPIKEY, SEGMENTAPIKEY, CLIENT_ID, MSTENANT, MUI_KEY, SCOPE, ONBOARDAPIURL, REFERRALAPIURL, VERSION, VERSION_DATE, env, CERBOSURL, JITSI_SERVER_URL};
